import { Injectable, effect, inject } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { LanguageService } from './language.service';

@Injectable({ providedIn: 'root' })
export class DatepickerLocaleService {
  private readonly dateAdapter = inject<DateAdapter<Date>>(DateAdapter);
  private readonly languageService = inject(LanguageService);

  constructor() {
    effect(() => {
      this.dateAdapter.setLocale(this.languageService.locale());
    });
  }
}
